<app-loader *ngIf="isDisabled"></app-loader>
<div class="single-row-container">
    <div class="header-row">
        <i class="fas fa-database"></i>
        <span>Upload Master - Select master name, upload Excel, or download sample file</span>
    </div>

    <div class="main-row">
        <!-- Master Selection -->
        <div class="control-group" style="width: 270px;">
            <span class="control-label">
                <i class="bi bi-list-ul"></i> Master:
            </span>
            <ng-select [appendTo]="'body'" name="branch" [items]="Masters" bindLabel="ExcelUploadName" bindValue="ESS_ExcelUploadMasterID"
                [(ngModel)]="this.Filter.ESS_ExcelUploadMasterId" placeholder="Select Master"
                (change)="setallowsubmit()"
                style="width: -webkit-fill-available;">
            </ng-select>
        </div>

        <!-- File Upload -->
        <div class="control-group">
            <span class="control-label">
                <i class="bi bi-file-earmark-arrow-up-fill"></i> Upload:
            </span>
            <div class="file-upload-wrapper" *ngIf="this.uploadfile == null">
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInputChange($event)"
                    accept=".xlsx,.xls,.csv">
                <label type="button" role="button" class="upload-btn" id="browseBtn" for="file-upload">
                    <i class="bi bi-folder2-open"></i>
                    Browse
                </label>
                <div class="formats">
                    <span class="format-tag">.xlsx</span>
                    <span class="format-tag">.xls</span>
                    <span class="format-tag">.csv</span>
                </div>
            </div>
            <div id="fileStatus" class="file-status" *ngIf="this.uploadfile != null">
                <i class="fas fa-check-circle"></i>
                <span id="fileName">{{this.uploadfile.name}}</span>
                <button class="remove-btn" id="removeFile" (click)="removeFile()">
                    <i class="bi bi-x-circle-fill"></i>
                </button>
            </div>
        </div>

        <!-- Sample Download -->
        <div class="control-group">
            <span class="control-label">
                <i class="bi bi-file-arrow-down-fill"></i> Sample:
            </span>
            <button type="button" class="sample-btn" id="downloadSampleBtn" (click)="downloadExcel()">
                <i class="bi bi-file-earmark-excel-fill"></i> Download
            </button>
        </div>

        <!-- Upload Action -->
        <button type="button" class="action-btn" id="uploadBtn" (click)="uploadfileData()"
            [disabled]="this.uploadfile == null">
            <i class="bi bi-upload"></i> Upload
        </button>
    </div>
</div>


<div class="container mt-2">
    <div class="card border-radius-0" style="border-width: 0;">
        <div class="card-body">
            <div class="recent-uploads" *ngIf="this.FillData.length > 0">
                <div class="row">
                    <div class="col">
                        <h4><i class="bi bi-database-add"></i> Recent Uploads</h4>
                    </div>
                    <div class="col-auto">
                        <button type="button" (click)="reset()" class="btn btn-sm btn-outline-danger delete-btn"
                            title="Delete" style="color: rgb(236, 4, 4);"><i class="bi bi-arrow-counterclockwise"></i>
                            Reset</button>
                    </div>
                </div>

                <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="excelData"
                    class="customeDatatable table table-bordered" name="excelData">
                </table> -->
            </div>
        </div>
        <!-- <div class="card-footer" style="bottom:-18px">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end"> -->
                <!-- <button type="button" class="btn btn-outline-secondary btn-sm"><i class="bi bi-x"></i>Close</button> -->

                <!-- <button *ngIf="this.allowsubmit" type="button" class="btn btn-primary btn-sm" (click)="submit()"><i
                        class="bi bi-pass"></i>Submit</button> -->
            <!-- </div>
        </div> -->
    </div>
</div>